import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const CookieSettingsModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [preferences, setPreferences] = useState(() => {
    const stored = localStorage.getItem('cookiePrefs');
    return stored ? JSON.parse(stored) : {
      essential: true,
      performance: false,
      functional: false,
      marketing: false,
    };
  });

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setPreferences((prev) => ({ ...prev, [name]: checked }));
  };

  const savePrefs = () => {
    localStorage.setItem('cookiePrefs', JSON.stringify(preferences));
    localStorage.setItem('cookieConsent', 'true');
    onClose();
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">{t('cookie_settings')}</h2>
        <form>
          <div className="mb-2">
            <label className="flex items-center">
              <input type="checkbox" checked disabled name="essential" className="mr-2" />
              <span>{t('cookie_essential')}</span>
            </label>
            <p className="text-xs text-gray-500 ml-6">{t('cookie_essential_desc')}</p>
          </div>
          <div className="mb-2">
            <label className="flex items-center">
              <input type="checkbox" name="performance" checked={preferences.performance} onChange={handleChange} className="mr-2" />
              <span>{t('cookie_performance')}</span>
            </label>
            <p className="text-xs text-gray-500 ml-6">{t('cookie_performance_desc')}</p>
          </div>
          <div className="mb-2">
            <label className="flex items-center">
              <input type="checkbox" name="functional" checked={preferences.functional} onChange={handleChange} className="mr-2" />
              <span>{t('cookie_functional')}</span>
            </label>
            <p className="text-xs text-gray-500 ml-6">{t('cookie_functional_desc')}</p>
          </div>
          <div className="mb-2">
            <label className="flex items-center">
              <input type="checkbox" name="marketing" checked={preferences.marketing} onChange={handleChange} className="mr-2" />
              <span>{t('cookie_marketing')}</span>
            </label>
            <p className="text-xs text-gray-500 ml-6">{t('cookie_marketing_desc')}</p>
          </div>
        </form>
        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onClose} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">{t('cookie_reject_all')}</button>
          <button onClick={savePrefs} className="px-4 py-2 rounded bg-gold text-black font-bold hover:bg-yellow-400">{t('cookie_save_preferences')}</button>
        </div>
      </div>
    </div>
  );
};

export default CookieSettingsModal;
